<div class="container padding-top padding-bottom">
  <md-card>
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class='btn btn-lg btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>Portable Settings</h1>
        <h3><b>{{clientData?.name}}</b></h3>
        <div *ngIf="clientData && !clientData?.portableMode"
             class="error">
          Warning: Portable Mode not enabled. <a (click)="clientData.portableMode = true; updateClient()">Enable Now</a>
        </div>
      </div>
    </div>

    <div *ngIf="!showLoading; else loading"
         class="row padding-bottom">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.isOnlyPortable">
              This client is portable units ONLY
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.useOnlyUnitsMarkedMobile">
              Only Show Units Marked 'Portable' in Sitelink on Portable Checkout
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.prepayAllDeliveries">
              Prepay All Deliveries (else just the initial)
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.redirectFromUnitsPage">
              Redirect from Units Page
            </md-slide-toggle>
          </div>
          <div *ngIf="clientData.portableInfo.redirectFromUnitsPage"
               class="col-xs-12 sm-margin-top">
            <label>Redirect to page (get-quote is the default, leave out '/' at the beginning of the route)</label>
            <input pInputText
                   [(ngModel)]="clientData.portableInfo.unitsPageRedirect" />
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.isDeliveryByZipCode">
              Delivery Area by Zip Code (Radius if false)
            </md-slide-toggle>
          </div>
          <div *ngIf="clientData.portableInfo.isDeliveryByZipCode"
               class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.useDeliveryZones">
              Enable Zones
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <label style="display: block">Map Radius -- Google map circle ONLY -- See location for actual delivery
              distance</label>
            <input pInputText
                   [(ngModel)]="clientData.portableInfo.mapRadius" />
          </div>
          <div class="col-xs-12 sm-margin-top">
            <p>Storage Type Options (Defaults to all)</p>
            <p-multiSelect [styleClass]="'full-width'"
                           [options]="quoteTypeOptions"
                           [(ngModel)]="clientData.portableInfo.quoteTypeOptions"></p-multiSelect>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <p>Store At Options (Defaults to all)</p>
            <p-multiSelect [styleClass]="'full-width'"
                           [options]="storeAtOptions"
                           [(ngModel)]="clientData.portableInfo.storeAtOptions"></p-multiSelect>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <p>Locations Offering Portable Storage</p>
            <p-multiSelect [styleClass]="'full-width'"
                           [options]="options"
                           [(ngModel)]="clientData.portableInfo.locations"></p-multiSelect>
          </div>

          <!-- <div class="col-xs-12 col-md-6 sm-margin-top">
            <label>Final Pickup Fee ID</label>
            <input pInputText
                   [(ngModel)]="clientData.portableInfo.finalPickUpFeeId" />
          </div> -->
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <label>Earliest Delivery Time (number of days)</label>
            <input pInputText
                   type="number"
                   [(ngModel)]="clientData.portableInfo.minDays" />
          </div>
          <div class="col-xs-12 sm-margin-top">
            <label for="portable-next-delivery-date">Next Earliest Delivery Date</label>
            <input class="full-width"
                   pInputText
                   type="date"
                   id="portable-next-delivery-date"
                   placeholder="mm/dd/yyyy"
                   [(ngModel)]="clientData.portableInfo.nextDeliveryDate" />
          </div>
          <div class="col-xs-12 sm-margin-top">
            <h3>Disable Days for Delivery</h3>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[0]">
              Sunday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[1]">
              Monday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[2]">
              Tuesday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[3]">
              Wednesday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[4]">
              Thursday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[5]">
              Friday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="clientData.portableInfo.disableDays[6]">
              Saturday
            </md-slide-toggle>
          </div>
        </div>
      </div>
    </div>
    <div class="row padding-top">
      <div class="col-md-12">
        <button style="float: right;"
                (click)="updateClient()"
                class="btn btn-lg btn-secondary"
                color="accent">Update</button>
      </div>
    </div>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/portable-settings/portable-settings.component.html